import { useMutation, useQuery } from "@tanstack/react-query";
import { httpClient, ROOT_URL } from "../App";
import { Store } from "sunflower-antd";

export const useGetListBankAccount = (params: {
  companyId: number;
  start: number;
  end: number;
  name?: string;
  currencyId?: number;
  ignoreId?: string;
}) => {
  return useQuery<{
    data: {
      data: {
        total: number;
        page: number;
        pageSize: number;
        totalPages: number;
        items: [];
      };
    };
  }>(
    [
      `/api/v1/bank_accounts/get-list`,
      params.companyId,
      params.start,
      params.end,
      params.name,
      params.currencyId,
      params.ignoreId,
    ],
    async () => getListBankAccount(params),
    {
      enabled: !!params.companyId,
    }
  );
};

export const useGetListBankAccountProvider = (params: {
  companyId: number;
  start: number;
  end: number;
  name?: string;
  currencyId?: number;
}) => {
  return useQuery<{
    data: {
      data: {
        total: number;
        page: number;
        pageSize: number;
        totalPages: number;
        items: [];
      };
    };
  }>(
    [
      `/api/v1/bank_accounts/get-list/provider`,
      params.companyId,
      params.start,
      params.end,
      params.name,
      params.currencyId,
    ],
    async () => getListBankAccount(params),
    {
      enabled: !!params.companyId,
    }
  );
};

export function getListBankAccount({
  companyId,
  start,
  end,
  name,
  currencyId,
  ignoreId,
}: {
  companyId: number;
  start: number;
  end: number;
  name?: string;
  currencyId?: number;
  ignoreId?: string;
}) {
  const params = new URLSearchParams();
  params.append("_start", String(start));
  params.append("_end", String(end));
  if (name) params.append("_like", name);
  if (currencyId) params.append("_currencyId", String(currencyId));
  if (ignoreId) params.append("_ignoreId", String(ignoreId));
  return httpClient.get(
    `${ROOT_URL}/api/v1/bank_accounts/companies/${companyId}/get-list?${params.toString()}`
  );
}

export const useGetDetailBankAcccount = (id: number) => {
  return useQuery<{ data: any }>(
    [`/api/v1/bank_accounts/detail/:id`, id],
    async () => {
      return getDetailBankAcccount(id);
    },
    {
      enabled: !!id,
    }
  );
};

export function getDetailBankAcccount(id: number | null) {
  return httpClient.get(`${ROOT_URL}/api/v1/bank_accounts/${id}`);
}

export const useCreateBankAccount = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: createBankAccount,
  });
};

export function createBankAccount(bank: Store) {
  return httpClient.post(`${ROOT_URL}/api/v1/bank_accounts/create`, bank);
}

export const useUpdateBankAccount = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: updateBankAccount,
  });
};

export function updateBankAccount(bank: Store) {
  return httpClient.patch(`${ROOT_URL}/api/v1/bank_accounts/update`, bank);
}

export const useDeleteBankAccount = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: deleteBankAccount,
  });
};

export function deleteBankAccount(id: number | null) {
  return httpClient.delete(`${ROOT_URL}/api/v1/bank_accounts/delete/${id}`);
}
